import { Chip, Paper } from "@mui/material";
import axios from "axios";
import * as React from "react";
import { Config } from "../../../config/config";
import { getGlobalVar, Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";

interface Props {
    playerId: string;
    activeEnv: any;
    heroesConfig: any;
    classes?: any;
    form?: any;
    playerData: any;
    fetchData(): void;
    changeProgress(e, type, id): void;
    deleteJob(type, id): void;
    data: any[];
}

export class PlayerAchievement extends React.Component<Props, any> {
    constructor(props) {
        super(props);
    }

    saveProgress = async (e, id, exists) => {
        try {
            await axios.put(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/achievements/${id}`, {
                progress: parseInt(e.target.value, 10),
                exists,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });
        } catch (error) {
            PopupMessage.error(`Something went wrong: ${error.message}`);
        }
    }

    displayAchievementsByRarity = (list: any[]) => list.map(item => {
        const database = this.props.data.find(achievement => achievement.id === item.id);

        return <Paper className="dailyJobs--item" key={item.id} elevation={0}>
            <div style={{ padding: "15px 10px", overflow: "hidden" }}>
                <div style={{ float: "left" }}>
                    <div>[<b>{item.id}</b>] {Helpers.getLocalizationName(item.title)}</div>
                    <div>{Helpers.getLocalizationName(item.description).replace("{0}", (item.goal || 0))}</div>
                </div>
                <div style={{ float: "right", paddingRight: 15, paddingTop: 5 }}>
                    <div style={{ display: "inline-block", paddingTop: 5 }}>
                        <span>
                            {Helpers.conditionPrint(this.props.playerData.is_online, <input
                                type="number"
                                value={database?.progress || 0}
                                style={{ width: (item.goal || 0) < 1000 ? 45 : 55, marginRight: 5 }}
                                max={item.goal || 0}
                                min={0}
                                className="simple-input"
                                onChange={(e) => this.props.changeProgress(e, "achievements", item.id)}
                                onBlur={(e) => this.saveProgress(e, item.id, database && !database.addedInPanel)}
                            />, database?.progress || 0)}
                        </span>
                        <span>/ {item.goal || 0}</span>
                    </div>
                </div>
            </div>
        </Paper>;
    })

    displayContracts = () => {
        // Group daily jobs by difficulty
        const groupedAchievements = getGlobalVar("ACHIEVEMENTS").reduce((list, item) => {
            if (!list[item.rarity]) {
                list[item.rarity] = [];
            }

            list[item.rarity].push(item);

            return list;
        }, {});

        return <React.Fragment>
            {Object.keys(groupedAchievements).map(rarity => (
                <div key={rarity}>
                    <Chip label={rarity.toUpperCase()}/>

                    <div className="dailyJobs--list">
                        {this.displayAchievementsByRarity(groupedAchievements[rarity])}
                    </div>
                </div>
            ))}
        </React.Fragment>;
    }

    render() {
        return this.displayContracts();
    }
}
